document.addEventListener("DOMContentLoaded", function () {
function initNewsletterForm(config) {
    const {
    contactTagsId,
    cb1Id,
    cb2Id,
    cb3Id,
    tenaMenSelector,
    tenaWomenSelector,
    tenaMenHiddenId,
    tenaWomenHiddenId,
    subscribeBtnId,
    shopifyBtnId,
    baseTags,
    dobId,
    dobErrorId,
    } = config;

    const contactTagsInput = document.getElementById(contactTagsId);
    const checkboxDataSharing = document.getElementById(cb1Id);
    const checkboxTermsConditions = document.getElementById(cb2Id); // Mandatory
    const checkboxDataPersonalization = document.getElementById(cb3Id);

    // TENA checkboxes
    const checkboxTenaMen = tenaMenSelector ? document.querySelector(tenaMenSelector) : null;
    const checkboxTenaWomen = tenaWomenSelector ? document.querySelector(tenaWomenSelector) : null;
    const tenaMenHidden = tenaMenHiddenId ? document.getElementById(tenaMenHiddenId) : null;
    const tenaWomenHidden = tenaWomenHiddenId ? document.getElementById(tenaWomenHiddenId) : null;

    // Buttons
    const subscribeButton = document.getElementById(subscribeBtnId);
    const shopifyNewsletterBottomBtn = shopifyBtnId ? document.getElementById(shopifyBtnId) : null;

    // Define tags
    const TAG_ALL_3_CHECKED = "accept_all";
    const TAG_CB1_CB2_CHECKED = "acceptDataSharing_and_tc";
    const TAG_CB2_CB3_CHECKED = "accept_tc_and_datapersonalization";
    const TAG_CB2_ONLY_CHECKED = "acceptTermsAndConditions";

    function updateContactTags() {
    let currentTags = [...baseTags];

    const isCb1Checked = checkboxDataSharing && checkboxDataSharing.checked;
    const isCb2Checked = checkboxTermsConditions && checkboxTermsConditions.checked;
    const isCb3Checked = checkboxDataPersonalization && checkboxDataPersonalization.checked;

    if (isCb1Checked && isCb2Checked && isCb3Checked) {
        currentTags.push(TAG_ALL_3_CHECKED);
    } else if (isCb1Checked && isCb2Checked && !isCb3Checked) {
        currentTags.push(TAG_CB1_CB2_CHECKED);
    } else if (!isCb1Checked && isCb2Checked && isCb3Checked) {
        currentTags.push(TAG_CB2_CB3_CHECKED);
    } else if (!isCb1Checked && isCb2Checked && !isCb3Checked) {
        currentTags.push(TAG_CB2_ONLY_CHECKED);
    }

    const dobInput = document.getElementById(dobId);
    if (dobInput && dobInput.value && !dobInput.hasAttribute("name")) {
        currentTags.push(`DOB:${dobInput.value}`);
    }

    // Get gender from checked radio and add as tag only
    const genderInput = document.querySelector('input[type="radio"][data-topic-gender]:checked');
    if (genderInput && genderInput.value) {
        currentTags.push(`Gender:${genderInput.value.toLowerCase()}`);
    }

    // Add TENA tags based on checkbox checked state
    // Only add TENA tags if checkboxes are present (enabled in settings)
    if (checkboxTenaMen) {
        currentTags.push(`TENA_MEN:${checkboxTenaMen.checked ? "true" : "false"}`);
    }
    if (checkboxTenaWomen) {
        currentTags.push(`TENA_WOMEN:${checkboxTenaWomen.checked ? "true" : "false"}`);
    }
    if (contactTagsInput) {
        contactTagsInput.value = [...new Set(currentTags)].join(",");
    }
    }

    function toggleSubmitButton() {
    const disableButtons = !(checkboxTermsConditions && checkboxTermsConditions.checked);
    if (subscribeButton) subscribeButton.disabled = disableButtons;
    if (shopifyNewsletterBottomBtn) shopifyNewsletterBottomBtn.disabled = disableButtons;
    }

    // Events
    if (checkboxDataSharing) checkboxDataSharing.addEventListener("change", updateContactTags);
    if (checkboxTermsConditions) {
    checkboxTermsConditions.addEventListener("change", updateContactTags);
    checkboxTermsConditions.addEventListener("change", toggleSubmitButton);
    }
    if (checkboxDataPersonalization) checkboxDataPersonalization.addEventListener("change", updateContactTags);

    if (checkboxTenaMen) checkboxTenaMen.addEventListener("change", updateContactTags);
    if (checkboxTenaWomen) checkboxTenaWomen.addEventListener("change", updateContactTags);

    // Update tags when DOB or Gender changes
    const dobInput = document.getElementById(dobId);
    if (dobInput && !dobInput.hasAttribute("name")) {
        dobInput.addEventListener("change", updateContactTags);
        dobInput.addEventListener("input", updateContactTags);
    }
        // Gender radios
        const genderRadios = document.querySelectorAll('input[type="radio"][name="gender"]');
        genderRadios.forEach(function(radio) {
            radio.addEventListener("change", updateContactTags);
        });

    // Init
    updateContactTags();
    toggleSubmitButton();

    // --- DOB Validation ---
    if (dobId && dobErrorId) {
    const dobInput = document.getElementById(dobId);
    const errorDiv = document.getElementById(dobErrorId);
    if (dobInput) {
        const today = new Date().toISOString().split("T")[0];
        dobInput.max = today;
        // Prevent dates earlier than 1900
        const minDate = "1900-01-01";
        dobInput.min = minDate;

        function validateDOB() {
        const value = dobInput.value;
        errorDiv.style.display = "none";
        dobInput.setCustomValidity("");

        if (!value) return true;

        const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
        if (!dateRegex.test(value)) {
            errorDiv.textContent = dob_wrong_format;
            errorDiv.style.display = "block";
            dobInput.setCustomValidity("Invalid format");
            return false;
        }

        const selectedDate = new Date(value + "T00:00:00");
        const now = new Date();
        if (selectedDate > now) {
            errorDiv.textContent =  dob_future_date;
            errorDiv.style.display = "block";
            dobInput.setCustomValidity("Future dates not allowed");
            return false;
        }
        const selectedYear = selectedDate.getUTCFullYear();
        if (selectedYear < 1900) {
            // dob_too_early should be defined similar to dob_wrong_format in your translations/messages
            errorDiv.textContent = dob_before_date || "Please select a year from 1900 or later.";
            errorDiv.style.display = "block";
            dobInput.setCustomValidity("Date must be 1900 or later");
            return false;
        }

        dobInput.setCustomValidity("");
        errorDiv.style.display = "none";
        return true;
        }

        dobInput.addEventListener("change", validateDOB);
        dobInput.addEventListener("blur", validateDOB);
        dobInput.addEventListener("input", function () {
        dobInput.setCustomValidity("");
        errorDiv.style.display = "none";
        });
        if (dobInput.form && dobInput.hasAttribute("name")) {
        dobInput.form.addEventListener("change", function () {
        if (!dobInput.value) {
            dobInput.removeAttribute("name");
        } else {
            dobInput.setAttribute("name", "contact[note][DOB]");
        }
        });
        }
    }
    }
}

// --- Init both forms with config ---
initNewsletterForm({
    contactTagsId: "ContactTags",
    cb1Id: "gdpr_compliance_data_sharing",
    cb2Id: "gdpr_compliance_terms_conditions",
    cb3Id: "gdpr_compliance_data_personalization",
    tenaMenSelector: "input[data-topic='TENA_MEN']",
    tenaWomenSelector: "input[data-topic='TENA_WOMEN']",
    tenaMenHiddenId: "tena-men-hidden",
    tenaWomenHiddenId: "tena-women-hidden",
    subscribeBtnId: "Subscribe",
    shopifyBtnId: "shopify-newsletter-bottom-btn",
    baseTags: ["newsletter", "gdpr-consent-given", "form-submitted"],
    dobId: "DOB--newsletter",
    dobErrorId: "dob-error",
});

initNewsletterForm({
    contactTagsId: "ContactTagsPopup",
    cb1Id: "gdpr_compliance_data_sharing_popup",
    cb2Id: "gdpr_compliance_terms_conditions_popup",
    cb3Id: "gdpr_compliance_data_personalization_popup",
    tenaMenSelector: "input[data-topic-popup='TENA_MEN']",
    tenaWomenSelector: "input[data-topic-popup='TENA_WOMEN']",
    tenaMenHiddenId: "popup-tena-men-hidden",
    tenaWomenHiddenId: "popup-tena-women-hidden",
    subscribeBtnId: "custom-hubspot-subscribe",
    shopifyBtnId: "shopify-newsletter-bottom-btn",
    baseTags: ["newsletter-popup", "gdpr-consent-given", "form-submitted"],
    dobId: "DOB--newsletter_popup",
    dobErrorId: "dob-error_popup",
});
});
